import { render, staticRenderFns } from "./WarningBadges.vue?vue&type=template&id=a4ec794a&scoped=true"
import script from "./WarningBadges.vue?vue&type=script&lang=js"
export * from "./WarningBadges.vue?vue&type=script&lang=js"
import style0 from "./WarningBadges.vue?vue&type=style&index=0&id=a4ec794a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec794a",
  null
  
)

export default component.exports